import { SiteNav, SiteFooter } from "@/pages/LandingPage";
import { Card, CardContent } from "@/components/ui/card";
import { Mail, MapPin, Globe } from "lucide-react";

export default function ContactUs() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="contact-us-page">
      <SiteNav />
      <main className="pt-16">
        <section className="py-20 px-6 bg-white">
          <div className="max-w-3xl mx-auto">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-ix-red-600 mb-3">Get In Touch</p>
            <h1 className="text-3xl sm:text-4xl font-bold text-ix-black tracking-tight mb-4">Contact Us</h1>
            <p className="text-base text-slate-600 mb-12">Have questions about ImpactX Bridge? We'd love to hear from you.</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Card className="bg-white border border-slate-200 shadow-sm">
                <CardContent className="p-6 flex flex-col items-center text-center">
                  <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-4">
                    <Mail className="w-5 h-5 text-ix-red-600" />
                  </div>
                  <h3 className="text-sm font-semibold text-ix-black mb-1">Email</h3>
                  <a href="mailto:connect@impactxbridge.com" className="text-sm text-ix-red-600 hover:underline">connect@impactxbridge.com</a>
                </CardContent>
              </Card>
              <Card className="bg-white border border-slate-200 shadow-sm">
                <CardContent className="p-6 flex flex-col items-center text-center">
                  <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-4">
                    <MapPin className="w-5 h-5 text-ix-red-600" />
                  </div>
                  <h3 className="text-sm font-semibold text-ix-black mb-1">Office</h3>
                  <p className="text-sm text-slate-500">Kerala, India</p>
                </CardContent>
              </Card>
              <Card className="bg-white border border-slate-200 shadow-sm">
                <CardContent className="p-6 flex flex-col items-center text-center">
                  <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-4">
                    <Globe className="w-5 h-5 text-ix-red-600" />
                  </div>
                  <h3 className="text-sm font-semibold text-ix-black mb-1">Website</h3>
                  <a href="https://impactxbridge.com" target="_blank" rel="noopener noreferrer" className="text-sm text-ix-red-600 hover:underline">impactxbridge.com</a>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
